import { defineMessages } from 'react-intl';

const translations = {
  timePlaceholder: {
    id: 'datePicker.timePlaceholder',
    defaultMessage: 'uu:mm',
    description: 'datepicker placeholder',
  },
  cancelLabel: {
    id: 'datePicker.cancelLabel',
    defaultMessage: 'CANCEL',
    description: 'datepicker cancel label',
  },
  clearLabel: {
    id: 'datePicker.clearLabel',
    defaultMessage: 'CLEAR',
    description: 'datepicker clear label',
  },
  okLabel: {
    id: 'datePicker.okLabel',
    defaultMessage: 'OK',
    description: 'datepicker ok label',
  },
  todayLabel: {
    id: 'datePicker.todayLabel',
    defaultMessage: 'TODAY',
    description: 'datepicker clear label',
  },
  toolbarTitle: {
    id: 'datePicker.toolbarTitle',
    defaultMessage: 'SELECT DATE',
    description: 'datepicker toolbar title',
  },
};

export default defineMessages(translations);
